import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ENDPOINTS, buildApiUrl } from '../../constants/apiendpoints.constant';
import { BehaviorSubject, Observable } from 'rxjs';
import { AtsCalculatorComponentState } from '../../models/ats.interface';

@Injectable({
  providedIn: 'root'
})
export class AtscalculatorService {
  private componentStateSubject = new BehaviorSubject<AtsCalculatorComponentState | null>(null);

  constructor(private http: HttpClient) { }

  ExportPdf(atsCalculationData: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.EXPORT_PDF_ATS);
    return this.http.post(appURL, atsCalculationData, {
      responseType: 'blob'
    });
  }

  saveComponentState(state: AtsCalculatorComponentState): void {
    this.componentStateSubject.next(state);
  }

  getComponentState(): AtsCalculatorComponentState | null {
    return this.componentStateSubject.value;
  }

  clearComponentState(): void {
    this.componentStateSubject.next(null);
  }
}
